import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import { connect } from 'react-redux';

import { SendSupportForm } from 'components/importer/import_requests/send_support_form';
import { changeField, saveRequest, sentToSupport, setErrors } from './store/actions/form';
import { getImportRequest, getSourceOptions, getPaths } from './store/selectors';

const SUPPORT_MESSAGE = 'Send this import request to Buildout\'s Data Team to take over the import process.';
const SENT_SUCCESS_MESSAGE = 'Your import request was sent to Buildout\'s Data Team!.';

export function SendSupportModal({
  importRequest,
  paths,
  shown,
  sourceOptions,
  onClose,
  onChange,
  onSentToSupport,
  onSetErrors,
  onSubmit
}) {
  const [send, setSend] = useState(false);

  const onCancel = () => {
    onClose(false);

    if (send) {
      window.location.assign(paths.databaseSettings);
    }
  };

  const handleFormSubmit = () => {
    onSentToSupport()
      .then(() => {
        setSend(true);
      }).catch((errors) => {
        onSetErrors(errors);
      });
  };

  const renderForm = () => {
    const formProps = {
      importRequest,
      sourceOptions,
      onSentToSupport,
      onChange,
      onSubmit
    };

    return (
      <SendSupportForm {...formProps} />
    );
  };

  const renderFooter = () => {
    if (send) {
      return <button className="btn btn-sm btn-save" onClick={onCancel}>Done</button>;
    }

    return (
      <React.Fragment>
        <button className="btn btn-sm btn-cancel" type="button" onClick={onCancel}>Cancel</button>
        <button className="btn btn-sm btn-save" type="button" onClick={handleFormSubmit}>Send to Support</button>
      </React.Fragment>
    );
  };

  return (
    <Modal show={shown} onHide={onCancel}>
      <Modal.Header closeButton>
        <Modal.Title>Send to Support</Modal.Title>
      </Modal.Header>
      <Modal.Body className="left-buffer-md">
        <div className="top-buffer-sm mb-4" name="sentToSupportMessage">
          {send ? SENT_SUCCESS_MESSAGE : SUPPORT_MESSAGE}&nbsp;
          A member of the team will be in touch via email with any questions,
          additional requirements, and on import completition.
        </div>
        {!send && renderForm()}
      </Modal.Body>
      <Modal.Footer>
        {renderFooter()}
      </Modal.Footer>
    </Modal>
  );
}

SendSupportModal.propTypes = {
  importRequest: PropTypes.object.isRequired,
  paths: PropTypes.object.isRequired,
  shown: PropTypes.bool.isRequired,
  sourceOptions: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onSentToSupport: PropTypes.func.isRequired,
  onSetErrors: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  importRequest: getImportRequest(state),
  paths: getPaths(state),
  sourceOptions: getSourceOptions(state)
});

const mapDispatchToProps = {
  onChange: changeField,
  onSubmit: saveRequest,
  onSetErrors: setErrors,
  onSentToSupport: sentToSupport
};

export default connect(mapStateToProps, mapDispatchToProps)(SendSupportModal);
